<template>
  <div>
    <organism-veeam-management
      v-if="filterData"
      :filter-list="filterData"
      :fields="fields"
      :items="veeamList"
      @onUpdateFilterData="onUpdateFilterData"
      @onUpdateCurrentPage="onUpdateCurrentPage"
      @onSetDefaultFilterData="onSetDefaultFilterData"
      @addVeeam="addVeeamToApi"
      @editVeeam="editVeeamToApi"
      @deleteVeeam="deleteVeeamToApi"
    ></organism-veeam-management>
  </div>
</template>

<script>
import {
  getVeeamList,
  addVeeam,
  editVeeam,
  deleteVeeam,
} from "@/api/api-module3"
import mixins from "@/mixins"
import { mapActions, mapGetters } from "vuex"
import OrganismVeeamManagement from "@/components/organisms/backupManagement/OrganismVeeamManagement.vue"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
export default {
  name: "VeeamManagement",
  mixins: [mixins, mixinsObjectHelper],
  components: { OrganismVeeamManagement },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "SERVER",
          thClass: "w-220px",
          tdClass: "w-220px",
        },
        {
          key: "ip",
          label: "IP ADDRESS",
          thClass: "w-200px",
          tdClass: "w-200px",
        },
        {
          key: "description",
          label: "DESCRIPTION",
        },
        {
          key: "deleteIcon",
          label: "",
          thClass: "w-150px",
          tdClass: "w-150px",
        },
      ],
      veeamList: [],
      filterData: null,
    }
  },
  computed: {
    ...mapGetters("appFilter", ["getBMMVeeamServerFilter"]),
  },
  watch: {
    currentServerVeeam() {
      if (this.hasString(this.currentServerVeeam.id)) {
        this.getDataFromApi()
      }
    },
  },
  async created() {
    await this.getDataFromApi()
  },
  methods: {
    ...mapActions("app", ["setVeeamList"]),
    ...mapActions("appFilter", ["setBMMVeeamServerFilter"]),

    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getBMMVeeamServerFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
    },

    async getDataFromApi() {
      await this.getVeeamListFromApi()
    },

    async getVeeamListFromApi() {
      this.showLoading(true)
      this.cloneFilterDataFromVuex()
      const filterData = this.filterDecoration()
      await getVeeamList(filterData)
        .then((response) => {
          this.filterData.totalCount = response.pagination.total
          const updatedFilter = {
            ...this.getBMMVeeamServerFilter,
            totalCount: response.pagination.total,
          }
          this.setBMMVeeamServerFilter(updatedFilter)
          this.veeamList = response.data.map((veeam) => {
            return {
              id: veeam.veeamId,
              name: veeam.veeamName,
              ip: veeam.veeamAddress,
              port: veeam.veeamPort,
              username: veeam.veeamUsername,
              description: veeam.veeamDescription,
            }
          })
        })
        .finally(() => this.showLoading(false))
      this.setVeeamList(this.veeamList)
    },

    filterDecoration() {
      const filter = {
        NameFilter: this.filterData.name || undefined,
        IpAddressFilter: this.filterData.ip || undefined,
        Page: this.filterData.currentPage,
        PageSize: 10,
      }
      return filter
    },

    // click filter
    onUpdateFilterData(filter) {
      filter.currentPage = 1
      this.setBMMVeeamServerFilter(filter)
      this.getVeeamListFromApi()
    },

    onSetDefaultFilterData() {
      const defaultFilter = {
        name: "",
        ip: "",
        currentPage: 1,
        totalCount: 0,
      }
      this.setBMMVeeamServerFilter(defaultFilter)
      this.getVeeamListFromApi()
    },

    onUpdateCurrentPage(filter) {
      const updatedFilter = {
        ...this.getBMMVeeamServerFilter,
        currentPage: filter.currentPage,
      }
      this.setBMMVeeamServerFilter(updatedFilter)
      this.getVeeamListFromApi()
    },

    async addVeeamToApi(request) {
      this.showLoading(true)
      await addVeeam(request)
        .then(async (create) => {
          if (create.status === "ok") {
            this.toastSuccess("Add successfully")
            await this.getDataFromApi()
          } else {
            this.toastError("Add failed")
          }
        })
        .catch(() => {
          this.toastError("Add failed")
        })
        .finally(() => this.showLoading(false))
    },

    async editVeeamToApi(id, request) {
      this.showLoading(true)
      await editVeeam(id, request)
        .then(async (editVeeam) => {
          if (editVeeam.status === "ok") {
            this.toastSuccess("Edit successfully")
            await this.getDataFromApi()
          } else {
            this.toastError("Edit failed")
          }
        })
        .catch(() => {
          this.toastError("Edit failed")
        })
        .finally(() => this.showLoading(false))
    },

    async deleteVeeamToApi(id) {
      this.showLoading(true)
      await deleteVeeam(id)
        .then(async (deleteVeeam) => {
          if (deleteVeeam.status === "ok") {
            this.toastSuccess("Delete successfully")
            await this.getDataFromApi()
          } else {
            this.toastError("Delete failed")
          }
        })
        .catch(() => {
          this.toastError("Delete failed")
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
